module.exports = __webpack_public_path__ + "img/dtj.a5ae7e48.png";